// extracted by mini-css-extract-plugin
export default {"loadingContainer":"QuestionnaireVariableConfiguration_loadingContainer__pqpPs"};